import {Box, Card, CardContent, Container, Stack, Typography} from '@mui/material';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import ASLogo from "../assets/logo/as_logo_small.png";
import React from "react";
import {grey} from "@mui/material/colors";

export default function RateLimitReached() {

    return <Container component="main" maxWidth="xs">
        <Box
            sx={{
                marginTop: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <img src={ASLogo} alt='Aglaia Sense' style={{width: '60%'}}/>
            <Typography component="h1" variant="h5" color="#323232" sx={{mb: 3, mt: 1, fontWeight: 'bold'}}>
                Device Manager
            </Typography>
            <Card elevation={3} sx={{width: 500, borderRadius: 3, overflow: 'hidden', mt: 20}}>
                <Box
                    sx={{
                        bgcolor: grey[800],
                        color: '#FFFFFF',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        p: 2,
                    }}
                >
                    <ReportProblemRoundedIcon fontSize="large"/>
                    <Typography variant="h6" component="h1">
                        You’ve reached the rate limit
                    </Typography>
                </Box>

                <CardContent sx={{p: 3}}>
                    <Stack spacing={1.25}>
                        <Typography variant="body1">
                            We’re receiving a high number of requests from your session. Please try again later.
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    </Container>
}